import React from "react";
import Coin from "../../../../Images/adhyayi_coin.png";
import { FaArrowTrendDown, FaArrowTrendUp } from "react-icons/fa6";
import { TrophyIcon } from "lucide-react";

const WalletCards = ({ userData ,userAnalaysis }) => {
 
  const questionSolved = (  userData?.quizStats?.totalRight || 0) + (userData?.quizStats?.totalWrong || 0);
 
const quizTransaction =
  userAnalaysis?.quiz?.lastTransaction;

const isQuizIncrease =
  quizTransaction?.isEarned;

const quizDifference =
  quizTransaction?.amount || 0;

  return (
    <div className="w-full border border-yellow-200 bg-white rounded-3xl p-4 shadow-[0_12px_24px_rgba(0,0,0,0.12)]">

      {/* Top Row */}
      <div className="flex items-center justify-between">
        
        {/* Left Icon */}
        <div className="w-10 h-10 rounded-2xl flex items-center bg-yellow-100 rounded-full justify-center">
          <TrophyIcon className="text-2xl text-[#FF7A45]" />
        </div>

        {/* Right Test Count */}
        <p className="text-bgBlue bg-purple-100 p-2 rounded-[10px] text-sm font-medium">
          {questionSolved} Questions
        </p>
      </div>

      {/* Title */}
      <h2 className="text-xl font-bold text-black text-left">
        Play Quiz
      </h2>

     {/* Coins */}
<div className="flex items-center gap-2">
  <img
    src={Coin}
    alt="coin"
    className="w-12 h-12 object-contain"
  />

  <div className="flex items-center gap-1">
    <p className="text-md font-semibold text-[#5A5A5A] leading-none">
      {userData?.unifiedWallet?.lockedBalance || 0}
    </p>

    <p className="text-sm text-gray-500 leading-none">
      Total Credits
    </p>
  </div>
</div>

      {/* Reward */}
  <div
  className={`flex items-center justify-center w-36 gap-2 p-2 rounded-[10px] text-sm font-medium ${
    isQuizIncrease
      ? "bg-green-100 text-green-600"
      : "bg-red-100 text-red-500"
  }`}
>
  {isQuizIncrease ? (
    <FaArrowTrendUp />
  ) : (
    <FaArrowTrendDown />
  )}

  <span>
    {isQuizIncrease ? "+" : "-"}
    {quizDifference} Credits
  </span>
</div>

    </div>
  );
};

export default WalletCards;